// extracted by mini-css-extract-plugin
module.exports = {"root":"_2a84c0","small":"_973ce6","subscript":"_9a8450","large":"_4fb7ca"};